var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 18.480132,12.019869 a 1.79,1.79 0 0 1 -0.51,1.28 l -10.380001,10.36 a 1.25,1.25 0 0 1 -1.76,-1.77 l 9.860001,-9.87 -9.860001,-9.86 a 1.25,1.25 0 0 1 1.76,-1.77000003 L 17.970132,10.739869 a 1.81,1.81 0 0 1 0.51,1.28 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.afb28646b783f9511a5f738aa88d0b78.svg";
export { ForwardRef as ReactComponent };